import React, { Component } from "react";

// Redux
import { connect } from "react-redux";

import "./FailedDisbursement.css";
// Select Action

import Retry from "./Retry/Retry";
import Details from "./Details/Details";

class FailedDisbursementModal extends Component {
  render() {
    const { properties } = this.props;
    const { action } = properties;

    return (
      <div className="Modal__dialog animated slideInDown" role="document">
        {(() => {
          switch (action) {
            case "details":
              return (
                <Details
                  properties={properties}
                  onCloseModal={this.props.onCloseModal}
                />
              );

            case "retry":
              return (
                <Retry
                  properties={properties}
                  onCloseModal={this.props.onCloseModal}
                />
              );

            default:
              return null;
          }
        })()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loansForDisbursement } = state.loansReducer;

  return {
    loansForDisbursement,
  };
};

export default connect(mapStateToProps)(FailedDisbursementModal);
